// LIST
export const FETCH_NEWS = "app/News/FETCH_NEWS";
export const FETCH_NEWS_SUCCESS = "app/News/FETCH_NEWS_SUCCESS";
export const FETCH_NEWS_FAILURE = "app/News/FETCH_NEWS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/News/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/News/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/News/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_NEWS = "app/News/ADD_NEWS";
export const ADD_NEWS_SUCCESS = "app/News/ADD_NEWS_SUCCESS";
export const ADD_NEWS_FAILURE = "app/News/ADD_NEWS_FAILURE";
// EDIT
export const EDIT_NEWS = "app/News/EDIT_NEWS";
export const EDIT_NEWS_SUCCESS = "app/News/EDIT_NEWS_SUCCESS";
export const EDIT_NEWS_FAILURE = "app/News/EDIT_NEWS_FAILURE";
// DELETE
export const DELETE_NEWS = "app/News/DELETE_NEWS";
export const DELETE_NEWS_SUCCESS = "app/News/DELETE_NEWS_SUCCESS";
export const DELETE_NEWS_FAILURE = "app/News/DELETE_NEWS_FAILURE";
